import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import { Link, Outlet, useLocation } from "react-router-dom";
import { FaCalendarDays } from "react-icons/fa6";
import { TbSettingsFilled } from "react-icons/tb";
import { BsPersonFillAdd } from "react-icons/bs";
import { IoPerson } from "react-icons/io5";
import { FaSackDollar } from "react-icons/fa6";
import { PiStarFill } from "react-icons/pi";
import { IoQrCodeSharp } from "react-icons/io5";
import { PiVideoFill } from "react-icons/pi";
import { FaTeamspeak } from "react-icons/fa";
import { ImExit } from "react-icons/im";
import { CircularProgress } from "@mui/material";
import { useDispatch } from "react-redux";
import { userlogout } from "../Redux/Action/AuthAction";
import { IoSettingsSharp } from "react-icons/io5";
import SettingModal from "../Modal/SettingModal";
import { useTranslation } from "react-i18next";
import { Dialog } from "@mui/material";
import { IoClose } from "react-icons/io5";
import { FiLogOut } from "react-icons/fi";
import Sidebar from "./Sidebar";

const DashboardLayout = () => {
  const [loading, setloading] = useState(false);
  const { t } = useTranslation("dashboardLayout");
  const [activeIndex, setActiveIndex] = useState(null);
  const dispatch = useDispatch();
  const [displayModal, setDisplayModal] = useState(false);
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  const handlesetting = () => {
    setDisplayModal(true);
  };

  const handleItemClick = (index) => {
    setActiveIndex(index);
    localStorage.setItem("activeIndex", index);
    if (window.innerWidth < 640) { // or any mobile breakpoint
      setSidebarOpen(false);
    }
  };

  const handleLogoutClick = () => {
    setOpenLogoutModal(true);
  };

  const handleCloseModal = () => {
    setOpenLogoutModal(false);
  };

  const handleConfirmLogout = () => {
    setOpenLogoutModal(false);
    dispatch(userlogout());
  };

  const location = useLocation();

  useEffect(() => {
    setloading(true);
    const sidebarItems = [
      // {
      //   name: t("dashboard"),
      //   icon: <VscDashboard size={25} />,
      //   path: "/dashboard",
      // },
      { name: t("events"), path: "/" },
      { name: t("configuration"), path: "/Configuration" },
      { name: t("addYourGuests"), path: "/AddGuest" },
      { name: t("yourGuests"), path: "/GuestList" },
      { name: t("rate"), path: "/Rate" },
      { name: t("yourTestimonials"), path: "/Testimonials" },
      { name: t("qrCode"), path: "/QRCode" },
      { name: t("videoTutorials"), path: "/VideoTutorials" },
      { name: t("contactUs"), path: "/ContactUs" },
    ];

    const currentPath = location.pathname;

    const matchingIndex = sidebarItems.findIndex(
      (item) => item.path === currentPath
    );

    if (matchingIndex !== -1) {
      setActiveIndex(matchingIndex);
    } else {
      setActiveIndex(0);
    }

    setloading(false);
  }, [location.pathname, t]);

  const sidebarItems = [
    // {
    //   name: t("dashboard"),
    //   icon: <VscDashboard size={25} />,
    //   path: "/dashboard",
    // },
    { name: t("events"), icon: <FaCalendarDays size={25} />, path: "/" },
    {
      name: t("configuration"),
      icon: <TbSettingsFilled size={25} />,
      path: "/Configuration",
    },
    {
      name: t("addYourGuests"),
      icon: <BsPersonFillAdd size={25} />,
      path: "/AddGuest",
    },
    { name: t("yourGuests"), icon: <IoPerson size={25} />, path: "/GuestList" },
    { name: t("rate"), icon: <FaSackDollar size={25} />, path: "/Rate" },
    {
      name: t("yourTestimonials"),
      icon: <PiStarFill size={25} />,
      path: "/Testimonials",
    },
    { name: t("qrCode"), icon: <IoQrCodeSharp size={25} />, path: "/QRCode" },
    {
      name: t("videoTutorials"),
      icon: <PiVideoFill size={25} />,
      path: "/VideoTutorials",
    },
    {
      name: t("contactUs"),
      icon: <FaTeamspeak size={25} />,
      path: "/ContactUs",
    },
  ];

  return (
    <>
      {loading ? (
        <div className="w-full h-[100vh] flex justify-center items-center">
          <CircularProgress size="3rem" />
        </div>
      ) : (
        <>
          <Navbar toggleSidebar={toggleSidebar} />

          <Sidebar
            sidebarOpen={sidebarOpen}
            sidebarItems={sidebarItems}
            activeIndex={activeIndex}
            handleItemClick={handleItemClick}
            handleLogoutClick={handleLogoutClick}
            handlesetting={handlesetting}
            t={t}
          />
          <Outlet />
        </>
      )}
      <SettingModal displayModal={displayModal} setDisplayModal={setDisplayModal} />

      {/* Logout Confirmation Modal */}
      <Dialog
        open={openLogoutModal}
        onClose={handleCloseModal}
        PaperProps={{
          sx: {
            borderRadius: "20px",
            width: "300px",
          },
        }}
      >
        <div className="bg-white p-7 flex flex-col gap-5 rounded-[20px]">
          <div className="flex items-start justify-end w-full">
            <span onClick={handleCloseModal}>
              <IoClose size={25} className="cursor-pointer" />
            </span>
          </div>
          <div className="text-center flex flex-col justify-items-center gap-8">
            <span className="bg-white rounded-full text-center mx-auto p-4 border-[2px] border-[#ED3939]">
              <FiLogOut color="#ED3939" size={26} />
            </span>
            <div>
              <div className="text-[20px] font-[600]">{t('logOut')}</div>
              {t('logoutConformation')}
            </div>
            <div className="flex gap-5 justify-center">
              <button
                className="bg-[#EDF4FF] text-black rounded-lg h-[40px] w-full max-w-32 my-1 text-[14px] text-center"
                onClick={handleCloseModal}
              >
                {t('cancel')}
              </button>
              <button
                onClick={handleConfirmLogout}
                className="bg-[#ED3939] text-white rounded-lg h-[40px] w-full max-w-32 my-1 text-[14px] text-center"
              >
                {t('logOut')}
              </button>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default DashboardLayout;
